module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "qb-showdown.401925bc.png";